// @flow

import React from 'react';
import { observer } from 'mobx-react';
import { Element } from 'react-scroll';
import { css } from 'glamor';

import type { User } from '~/types';

import Contributor from '~/components/global/Contributor';

const list = css({
    listStyle: 'none',
});

const listItem = css({
    display: 'inline-block',
    margin: '5px',
});

const fullListItem = css({
    display: 'block',
    marginTop: '15px',
    padding: '20px',
    backgroundColor: '#f5f5f5',
    color: '#333',
    textAlign: 'justify',

    '& .name': {
        color: '#333',
        fontSize: '1.2em',
    },

    '& h3': {
        position: 'relative',

        marginTop: '10px',
        paddingLeft: '15px',
        paddingTop: '7px',
        paddingBottom: '7px',

        color: 'rgb(228, 65, 34)',
        fontStyle: 'italic',
        fontWeight: 500,
        fontSize: '1.2em',
        letterSpacing: '1px',
        wordSpacing: '5px',

        overflow: 'auto',

        '&:before': {
            backgroundColor: '#b7b7b7',
            position: 'absolute',
            bottom: '7px',
            top: '7px',
            left: 0,
            content: '""',
            width: '3px',
        },
    },
});

@observer
export default class ContributorList extends React.Component {
    props: {
        contributors: Array<User>,
        displayDetails?: boolean,
        anchor?: boolean,
        full?: boolean,
    };

    render() {
        const {
            contributors,
            displayDetails,
            anchor,
            full,
            ...rules
        } = this.props;
        const styles = full ?
        {
            listItem: fullListItem,
        } :
        {
            listItem,
        };

        return (
            <ul { ...list } { ...rules }>
                {contributors &&
                    contributors.map(contributor => (
                        <li key={ contributor.id } { ...styles.listItem }>
                            {anchor ?
                                <Element name={ contributor.slug }>
                                      <Contributor
                                          user={ contributor }
                                          displayDetails={ displayDetails }
                                          full={ full }
                                      />
                                  </Element> :
                                <Contributor
                                    user={ contributor }
                                    displayDetails={ displayDetails }
                                    full={ full }
                                />}
                        </li>
                    ))}
            </ul>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/global/ContributorList/index.js